<template>
  <v-layout row class="ma-0">
    <v-flex>
      <span class="page_ncc1 d-felx align-center ft-size12 pa-0" v-html="$t('common.pagination.total_count', {startIndex: startIndex, endIndex: endIndex, totalCount: paging.totalCount})"></span>
    </v-flex>
    <v-flex class="page_nation_numb_wrap">
      <v-btn class="page_move_btn" @click="fnGoPage(1)">
        <v-icon>mdi-chevron-double-left</v-icon>
      </v-btn>
      <v-btn class="page_move_btn" v-if="paging.page > pageSize" @click="fnGoPage(tempPage - 1)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-spacer class="hidden_lr2 d-inlineb"></v-spacer>
      <template v-for="n in (pageSize + 1)">
        <template v-if="((tempPage + n - 1) <= paging.pageCount) && n <= pageSize">
          <v-btn :class="{page_num_btn: true, actv: (paging.page === (tempPage + n - 1))}" :key="n" @click="fnGoPage(tempPage + n - 1)">{{tempPage + n - 1}}</v-btn>
        </template>
        <template v-if="((tempPage + n - 1) <= paging.pageCount) && n > pageSize">
          <v-spacer class="hidden_lr2 d-inlineb" :key="n"></v-spacer>
          <v-btn class="page_move_btn" :key="n + 1" @click="fnGoPage(tempPage + n - 1)">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </template>
      </template>
      <v-spacer class="hidden_lr2 d-inlineb"></v-spacer>
      <v-btn class="page_move_btn" @click="fnGoPage(paging.pageCount)">
        <v-icon>mdi-chevron-double-right</v-icon>
      </v-btn>
    </v-flex>

    <v-flex>
      <span>{{$t('common.pagination.row_per_page')}}</span>
      <v-spacer class="hidden_lr4 d-inlineb"></v-spacer>
      <v-select
        class="select_h27 w-70 d-inlineb"
        hide-details
        v-model="paging.pageSize"
        :items="rowPages"
        @change="fnSetPageSize"
        solo
        flat
      ></v-select>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    paging: {
      type: Object
    }
  },
  components: {
  },
  data () {
    return {
      rowPages:[10, 20, 30, 50, 100],
      pageSize: 10
    }
  },
  computed: {
    startIndex () {
      return (this.paging.page - 1) * this.paging.pageSize + 1
    },
    endIndex () {
      return (this.paging.page * this.paging.pageSize > this.paging.totalCount) ? this.paging.totalCount : this.paging.page * this.paging.pageSize
    },
    tempPage () {
      let page = parseInt((this.paging.page - 1) / this.pageSize, 10) * this.pageSize + 1

      return page
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    /**
     * 페이지 이동
     */
    fnGoPage(page) {
      if (this.paging.pageCount > 0) {
        this.paging.page = page
        this.$emit('page', this.paging)
      }
    },

    fnSetPageSize() {
      this.$emit('pageSize', this.paging)
    }
  }
}
</script>